
import axios from 'axios';

// app config
import AppConfig from 'Constants/AppConfig';
import AuthHeader from 'Constants/AuthHeader';
import {
    PUTTPERFORMANCE_ACTION,
    ALL_PUTTPERFORMANCE,
    ADD_PUTTPERFORMANCE,
    FETCH_PUTTPERFORMANCE,
    EDIT_PUTTPERFORMANCE,
    DELETE_PUTTPERFORMANCE,
    FETCH_PUTTDISTANCE,
    FETCH_PUTTPERFORMANCECHART,
} from 'Actions/types';

import { NotificationManager } from 'react-notifications';
/**
 * Putt Performance Actions
 */

    export const allPuttPerformance = () =>{    
        
        return (dispatch) => { 
            dispatch({ type: PUTTPERFORMANCE_ACTION });
            return axios.get(AppConfig.apiurl+'/api/getputtperformance', { headers: AuthHeader.header })         
            .then(response => {             
                const alldata=response.data.data;
                dispatch({ type: ALL_PUTTPERFORMANCE, payload: alldata });
            });
        }        

    }

    export const studentPuttPerformance = (id, start, end) =>{
    
        var payload={
            "id":id,
            "startdate":start,
            "enddate":end
        }

        return (dispatch) => { 
            dispatch({ type:PUTTPERFORMANCE_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/studentputtperformance', payload,{ headers: AuthHeader.header })         
            .then(response => { 
                const alldata=response.data.data;
                dispatch({ type: ALL_PUTTPERFORMANCE, payload: alldata }); 
            });
        
        }
    }

    export const fetchPuttDistance = (id) =>{
    
        var payload={
            "id":id
        }
        return (dispatch) => { 
            dispatch({ type:PUTTPERFORMANCE_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/getputtdistance', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){              
                    dispatch({ type: FETCH_PUTTDISTANCE});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }

    export const addPuttPerformance = (data, sepmore) =>{
        var stdid=data.target.student.value;
        var payload={
            "totval":1,
            "student_1":data.target.student.value,
            "sgdate":data.target.seldate.value,
            "shtot_1":sepmore,
        }

        for (let i = 0; i<sepmore; i++) {        
            
           
            var right='right_'+i;            
            var rightval=data.target[right].value;
            var left='left_'+i;            
            var leftval=data.target[left].value;
            var short='short_'+i;            
            var shortval=data.target[short].value;
            var long='long_'+i;            
            var longval=data.target[long].value;
            var puttlength='puttlength_'+i;            
            var puttlengthval=data.target[puttlength].value;
            var noputt='noputt_'+i;            
            var noputtval=data.target[noputt].value;
            var avgputt='avgputt_'+i;            
            var avgputtval=data.target[avgputt].value;
            var strokes='strokes_'+i;            
            var strokesval=data.target[strokes].value;  
            var puttype='putttype_'+i;  
            var puttypeval=data.target[puttype].value;         
            
            var adval=i+1;            
            var rightadd='right_1_'+adval;  
            var leftadd='left_1_'+adval;  
            var shortadd='short_1_'+adval;  
            var longadd='long_1_'+adval;  
            var putlenadd='puttlength_1_'+adval;  
            var puttadd='putt_1_'+adval;      
            var avgputtadd='avgputt_1_'+adval; 
            var strokesadd='strokes_1_'+adval;   
            var puttypeadd='putttype_1_'+adval;            
           
            payload[rightadd]=rightval;
            payload[leftadd]=leftval;
            payload[shortadd]=shortval;
            payload[longadd]=longval;
            payload[putlenadd]=puttlengthval;
            payload[puttadd]=noputtval;           
            payload[avgputtadd]=avgputtval;
            payload[strokesadd]=strokesval;
            payload[puttypeadd]=puttypeval;            
    
        }        

        return (dispatch) => { 
            dispatch({ type:PUTTPERFORMANCE_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/addputtperformance', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){
                    var start='';
                    var end='';
                    studentPuttPerformance(stdid, start, end)(dispatch);
                    var distance='';
                    var type='';
                    fetchPuttPerformanceChart(stdid, start, end, distance, type)(dispatch);
                    NotificationManager.success(resdata.message);               
                    dispatch({ type: ADD_PUTTPERFORMANCE});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }

    export const fetchPuttPerformance = (id, date) =>{
    
        var payload={
            "id":id,
            "date":date
        }
        return (dispatch) => { 
            dispatch({ type:PUTTPERFORMANCE_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/getputtperformancedetails', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){              
                    dispatch({ type: FETCH_PUTTPERFORMANCE, payload: resdata.data});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }

    export const editPuttPerformance = (data, sepmore, oldate) =>{
        var stdid=data.target.student.value;
        var payload={
            "totval":1,
            "student":data.target.student.value,
            "sgdate":data.target.seldate.value,
            "shtot_1":sepmore,
            "olddate":oldate,
        }

        for (let i = 0; i<sepmore; i++) {       
                       
            var right='right_'+i;            
            var rightval=data.target[right].value;
            var left='left_'+i;            
            var leftval=data.target[left].value;
            var short='short_'+i;            
            var shortval=data.target[short].value;
            var long='long_'+i;            
            var longval=data.target[long].value;
            var puttlength='puttlength_'+i;            
            var puttlengthval=data.target[puttlength].value;
            var noputt='noputt_'+i;            
            var noputtval=data.target[noputt].value;
            var avgputt='avgputt_'+i;            
            var avgputtval=data.target[avgputt].value;
            var strokes='strokes_'+i;            
            var strokesval=data.target[strokes].value;  
            var puttype='putttype_'+i;  
            var puttypeval=data.target[puttype].value;          
            
            var adval=i+1;            
            var rightadd='right_1_'+adval;  
            var leftadd='left_1_'+adval;  
            var shortadd='short_1_'+adval;  
            var longadd='long_1_'+adval;  
            var putlenadd='puttlength_1_'+adval;  
            var puttadd='putt_1_'+adval;      
            var avgputtadd='avgputt_1_'+adval; 
            var strokesadd='strokes_1_'+adval;   
            var puttypeadd='putttype_1_'+adval;         
           
            payload[rightadd]=rightval;
            payload[leftadd]=leftval;
            payload[shortadd]=shortval;
            payload[longadd]=longval;
            payload[putlenadd]=puttlengthval;
            payload[puttadd]=noputtval;           
            payload[avgputtadd]=avgputtval;
            payload[strokesadd]=strokesval;            
            payload[puttypeadd]=puttypeval; 
        } 

        return (dispatch) => { 
            dispatch({ type:PUTTPERFORMANCE_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/editputtperformance', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){
                    var start='';
                    var end='';
                    studentPuttPerformance(stdid, start, end)(dispatch);
                    var distance='';
                    var type='';
                    fetchPuttPerformanceChart(stdid, start, end, distance, type)(dispatch);
                    NotificationManager.success(resdata.message);               
                    dispatch({ type: EDIT_PUTTPERFORMANCE});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }

    export const deletePuttPerformance = (id, date) =>{
        
        var payload={
            "id":id,
            "date":date
        }
        
        return (dispatch) => { 
            dispatch({ type:PUTTPERFORMANCE_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/deleteputtperformance', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){
                    var start='';
                    var end='';
                    studentPuttPerformance(id, start, end)(dispatch);
                    var distance='';
                    var type='';
                    fetchPuttPerformanceChart(id, start, end, distance, type)(dispatch);
                    NotificationManager.success(resdata.message);               
                    dispatch({ type: DELETE_PUTTPERFORMANCE});                    
                }                
                
            });
        
        }
    }

    export const fetchPuttPerformanceChart = (id, start, end, distance, type) =>{
    
        var payload={
            "id":id,
            "startdate":start,
            "enddate":end,
            "distance":distance,
            "putttype":type          
        }

        return (dispatch) => { 
            dispatch({ type:PUTTPERFORMANCE_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/puttperformancereport', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data.data;                
                dispatch({ type: FETCH_PUTTPERFORMANCECHART, payload: resdata}); 
                
                return Promise.resolve(resdata);
                
            });
        
        }
    }


